
import { Link } from "react-router-dom";
import { Linkedin, Youtube } from "lucide-react";

const Footer = () => {
  // Scroll to top when navigating to a new page
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="border-t mt-auto py-8 md:py-12">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          <div className="col-span-2">
            <div className="mb-4">
              <img 
                src="/lovable-uploads/57439b0f-5e15-4120-81be-8e38208f0799.png" 
                alt="Upfixe Ads Logo" 
                className="h-14 w-auto" 
              />
            </div>
            <p className="text-muted-foreground text-sm mb-4">
              Automating Google Ads with precision and intelligence
            </p>
            <div className="flex space-x-4 mb-4">
              <a 
                href="https://www.linkedin.com/company/upfixe-ads" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Upfixe Ads on LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a 
                href="https://www.youtube.com/@upfixeads" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Upfixe Ads on YouTube"
              >
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-sm font-medium mb-3">Product</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/features" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Features
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  The 5-Group System
                </Link>
              </li>
              <li>
                <Link to="/bing-ads" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Bing Ads (Microsoft)
                </Link>
              </li>
              <li>
                <Link to="/compare" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Compare
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-medium mb-3">Plans</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/plans/solo" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Solo ($99)
                </Link>
              </li>
              <li>
                <Link to="/plans/agency" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Agency ($249)
                </Link>
              </li>
              <li>
                <Link to="/plans/studio" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Studio ($599)
                </Link>
              </li>
              <li>
                <Link to="/plans/enterprise" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Enterprise
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium mb-3">MCP & AI</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/mcp" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Google Ads MCP
                </Link>
              </li>
              <li>
                <Link to="/bing-ads" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Microsoft Ads MCP
                </Link>
              </li>
              <li>
                <Link to="/docs/mcp" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Claude & ChatGPT Docs
                </Link>
              </li>
              <li>
                <Link to="/google-ads-automation" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Automation Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium mb-3">Company</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/about" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  PPC Growth Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-medium mb-3">Legal</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/privacy" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/refund" className="hover:text-foreground transition-colors" onClick={handleLinkClick}>
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-sm text-muted-foreground mb-4 md:mb-0">
            <p>&copy; {new Date().getFullYear()} UPFIXE, UNIPESSOAL LDA. All rights reserved.</p>
          </div>
          <div className="flex space-x-4">
            <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={handleLinkClick}>
              Terms
            </Link>
            <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={handleLinkClick}>
              Privacy
            </Link>
            <Link to="/refund" className="text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={handleLinkClick}>
              Refund
            </Link>
            <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={handleLinkClick}>
              Contact
            </Link>
            <a
              href="https://upfixe.instatus.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Status
            </a>
            <a
              href="https://www.claudeai.directory"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Listed on Claude AI Directory
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
